import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "../../../components/AppLayout/AppLayout";
import RequestCash from "../../../components/FieldOperationsMiniDrawerMobile/RequestCash/RequestCash";
import RequestList from "../../../components/FieldOperationsMiniDrawerMobile/RequestList/RequestList";

export default function PettyCashRequest() {
  const [activeTab, setActiveTab] = useState("request-cash");
  const navigate = useNavigate();

  return (
  
  <>
   <AppLayout className= 'border-2px'
      title={activeTab === "request-cash" ? "Request Cash" : "Request List"}
      onBack={() => navigate(-1)}
    >

      {/* Breadcrumb */}
      <div style={{ background: "#fff", padding: "8px 14px", borderBottom: "0.5px solid #eee", display: "flex", gap: 6, alignItems: "center" }}>
        <span style={{ fontSize: 12, color: "#888" }}>Home</span>
        <span style={{ fontSize: 12, color: "#aaa" }}>›</span>
        <span style={{ fontSize: 12, color: "#888" }}>Petty Cash</span>
      </div>

      {/* Tabs */}
      <div style={{ background: "#fff", padding: "8px 14px", display: "flex", gap: 6, borderBottom: "0.5px solid #eee" }}>
        {["request-cash", "request-list"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: "8px 16px", fontSize: 13, cursor: "pointer", border: "none",
              borderRadius: activeTab === tab ? 6 : 0,
              background: activeTab === tab ? "#7c3ab5" : "none",
              color: activeTab === tab ? "#fff" : "#888",
              borderBottom: activeTab === tab ? "none" : "2px solid transparent",
            }}
          >
            {tab === "request-cash" ? "Request Cash" : "Request List"}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === "request-cash" ? <RequestCash /> : <RequestList />}

    </AppLayout>
  </>
   
  );
}